import { Favorites } from '@cloudmatize/traffic-hub'

export function FavoritesPage() {
  return <Favorites />
}
